/**!
* GK8 2024 Website - Application JS
* @version 1.0
* @author Sudarshan Thiagarajan
*/
;(function($){
  var app = {
    init: function(){
      // 
    },
    domReady: function(){
      var ww = $(window).width();

      app.initRive();
      app.initLottie();
      app.initFlowchart();
      app.initFeaturesAccordion();
      app.forceActiveAccordion();
      app.initScrollRevealHeading();
      app.initComeetPositions();
      app.loopHomeVideo();
      app.initAboutSlider();
      app.initNavA11y();
      app.initMobileNav();
      app.initTopAnnouncements();
      app.initBottomAnnouncement();
      app.initBlogLoadMore();
      app.initNewsLoadMore();
      app.initResourcesLoadMore();
      app.initUpcomingLoadMore();
      app.hashFixNavs();
      app.matchHeightElem();
      app.initSticksy();
      app.initVimeoVids();
      app.initNavReveal();
      app.handleHubspotConsentBottomAnnouncementMove();
      app.initTooltips();
      app.cloneEventInfoStrip();
      // app.resetPulledUpForm();
    },
    windowLoad: function(){
      // 
    },
    windowResizeScroll: function(e){
      // 
    },
    windowResize: function () {
      // 
    },
    initRive: function(){
      if( $('.rive--app').length > 0 ) {
        let riveCandidates = $('.rive--app');

        riveCandidates.each(function(){
          let target = $(this).data('rive-target');
          let artboard = $(this).data('rive-artboard');
          let statemachine = $(this).data('rive-state-machine');
          let source = $(this).data('rive-source');

          let layout = new rive.Layout({
            fit: rive.Fit.Cover,
            alignment: rive.Alignment.Center,
          });

          const r = new rive.Rive({
            src: source,
            canvas: document.getElementById(target),
            autoplay: true,
            artboard: decodeURIComponent(artboard),
            stateMachines: decodeURIComponent(statemachine),
            layout: layout,
            onLoad: () => {
              r.startRendering();
              r.resizeDrawingSurfaceToCanvas();
            },
          });
        });
      }
    },
    initNavReveal: function() {
      var lastScrollTop = 0, delta = 5;

      if( $(window).width() > 1025 ) {
        $(window).scroll(function(){
          var nowScrollTop = $(this).scrollTop();
          if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
            if (nowScrollTop > lastScrollTop){
              $('#wrapper-navbar').removeClass('stay-there');
            } else {
              $('#wrapper-navbar').addClass('stay-there');
            }
          lastScrollTop = nowScrollTop;
          }
        });
      } else {
        // var lastPoint = null;
        // $(window).on('touchend', function(e){
        //   var currentPoint = e.originalEvent.changedTouches[0].pageY;

        //   if(lastPoint != null && lastPoint < currentPoint ){
        //     $('#wrapper-navbar').addClass('stay-there');
        //   } else if(lastPoint != null && lastPoint > currentPoint){
        //     $('#wrapper-navbar').removeClass('stay-there');
        //   }
        //   lastPoint = currentPoint;
        // });
      }
    },
    initLottie: function(){
      if( $('.lottie-animation').length > 0 ) {
        let lottieCandidates = $('.lottie-animation');

        lottieCandidates.each(function(){
          let lottie_file = $(this).data('lottie-json');
          let lottie_id = $(this).attr('id');
          let lottie_behaviour = $(this).data('lottie-behaviour');

          if( lottie_behaviour == 'loop' || $(window).width() < 1025 ) {
            lottie.loadAnimation({
              container: document.getElementById(lottie_id),
              renderer: 'svg',
              loop: true,
              autoplay: true,
              path: lottie_file
            });
          } else {
            let iconHandler = document.getElementById(lottie_id);
            let lottieParent = document.getElementById(lottie_id).closest('.lottie-parent');
            
            let animationHandler = lottie.loadAnimation({
              container: iconHandler,
              renderer: 'svg',
              loop: false,
              autoplay: false,
              path: lottie_file
            });

            var directionMenu = 1;
              lottieParent.addEventListener('mouseenter', (e) => {
              animationHandler.setDirection(directionMenu);
              animationHandler.play();
            });

            lottieParent.addEventListener('mouseleave', (e) => {
              animationHandler.setDirection(-directionMenu);
              animationHandler.play();
            });
          }
        });
      }
    },
    initFlowchart: function(){
      if( $('.interactive-flowchart--pin-marker').length > 0 ) {
        let tooltipCandidate = $('.interactive-flowchart--pin-marker');

        tooltipCandidate.each(function(){
          let tooltipIndex = $(this).data('marker-index');
          let expandCandidate = $(document).find('.interactive-flowchart--tooltip-index-'+(tooltipIndex+1));

          $(this).on('mouseenter', function() {
            expandCandidate.addClass('show');
          });
          
          $(this).on('mouseout', function() {
            expandCandidate.removeClass('show');
          });
        });
      }
    },
    initFeaturesAccordion: function() {
      if( $('.features-accordion--container').length > 0 ) {
        let accordionCandidate = $('.features-accordion--container');

        accordionCandidate.each(function(){
          let accordionID = $(this).attr('id');
          let accordionParent = document.getElementById(accordionID);
          let accordionImages = $('.features-accordion--image-holder');
          let accordionItems = $('.accordion-item');

          accordionParent.addEventListener('shown.bs.collapse', function (e) {
            let targetEl = e.target.getAttribute('data-image-trigger');
            let targetImg = $(document).find('.features-'+(targetEl));
            accordionImages.removeClass('current');
            accordionItems.removeClass('current');

            let thisSrc = e.target.getAttribute('id');
            let thisParent = $(document).find('.accordion-item.'+thisSrc);

            thisParent.addClass('current');
            targetImg.addClass('current');
          });
        });
      }
    },
    forceActiveAccordion: function() {
      if( $('.features-accordion--container').length > 0 ) {
        const accordions = document.querySelectorAll(".accordion-collapse");
        let opening = false;
        accordions.forEach(function (el) {
          el.addEventListener("hide.bs.collapse", (event) => {
            if (!opening) {
              event.preventDefault();
              event.stopPropagation();
            } else {
              opening = false;
            }
          });
          el.addEventListener("show.bs.collapse", (event) => {
            opening = true;
          });
        });
      }
    },
    initScrollRevealHeading: function() {
      if( $('.scroll-reveal-heading').length > 0 ) {
        $(window).scroll(function(event) {
          let scroll = $(this).scrollTop() - 200;
          let opacity = 1 - ((scroll*2) / 1000);
          if (opacity >= 0) {
            $('#animated-reveal').css({ 'background': `linear-gradient(180deg, rgba(0, 0, 0, 0) ${(scroll*1.75)/10}%, rgba(0, 0, 0, 1) ${scroll*2.8/10}%)` });
            $('.scroll-reveal-heading .heading').css({ 'opacity': '1' });
          }
        });
      }
    },
    initNavA11y: function() {
      $('ul.nav.nav-common.nav-main li').hover(
        function () {
          $(this).addClass('hovered');
        },
        function () {
          $(this).removeClass('hovered');
        }
      );
    },
    initMobileNav: function() {
      const btnNav = $('.navbar-toggler');
      const mobileVisible = '.mobile-nav-open';
      const mainMenu = '.navbar';
      const active = '.active';
      const root = $('html');

      btnNav.on('click', function() {
        $('html').toggleClass('mobile-nav-open');
        $('.navbar-toggler').toggleClass('active');

        if ($('html').hasClass('mobile-nav-open')) {
          bodyScrollLock.disableBodyScroll('.navbar');
        } else {
          bodyScrollLock.enableBodyScroll('.navbar');
        }
      });
    },
    initTopAnnouncements: function() {
      if($('body').hasClass('top-announcement-active')){
        $(document).on('click', 'a#closeAnnBar', function(e){
          e.preventDefault();
          var validity = parseInt($(this).attr('data-expires'));
          var aid = $(this).attr('data-aid');

          app.deferTopAnnouncement(validity, aid);
        });
        
        $(document).on('click', '.mainAnnouncementCTA a.btn', function(e){
          //e.preventDefault();
          var validity = parseInt($(this).attr('data-expires'));
          var aid = $(this).attr('data-aid');

          app.deferTopAnnouncement(validity, aid);
        });
      }
    },
    deferTopAnnouncement: function(validity, aid) {
      Cookies.set('gk8_SuppressAnnouncement_'+aid, 'true', {expires: validity});
      
      $(document).find('.top-announcement-bar').remove();
      $('body').removeClass('top-announcement-active');
    },
    initBottomAnnouncement: function() {
      if( $('.bottom-announcement').length > 0 ) {
        var alreadySeen = sessionStorage.getItem('footer_announcement_suppressed');
        
        if( !alreadySeen ) {
          $('.bottom-announcement').addClass('show');
        }

        $(document).on('click', 'a.bottom-announcement-close', function(e){
          e.preventDefault();
          app.deferBottomAnnouncement();
        });
        
        $(document).on('click', '.bottom-announcement a.cta-bottom-announcement', function(e){
          //e.preventDefault();
          app.deferBottomAnnouncement();
        });
      }
    },
    deferBottomAnnouncement: function() {
      var validity = 1;
      Cookies.set('gk8_SuppressAnnouncement_footer', 'true', {expires: validity});
      sessionStorage.setItem('footer_announcement_suppressed', true);

      $(document).find('.bottom-announcement').remove();
    },
    initComeetPositions: function() {
      if( $('.comeet-listing').length > 0 ) {
        const options = {
          valueNames: [{ data: [ 'department' ]}, { data: [ 'location' ]}],
          pagination: false,
        };

        const listSelector = 'positions-list';
        const positionsList = new List(listSelector, options);

        const filters = {
          department: 'Department',
          location: 'Location',
        };

        $('.comeet-listing--filter-form select.comeet-listing--filter-department').select2({
          // 
        });
        
        $('.comeet-listing--filter-form select.comeet-listing--filter-location').select2({
          // 
        });

        $('.comeet-listing--filter-department').on('change', event => {
          filters.department = event.currentTarget.value;
          app.filterPostions(filters, positionsList);

          $('.comeet-listing--open-number').html(positionsList.matchingItems.length);
        });

        $('.comeet-listing--filter-location').on('change', event => {
          filters.location = event.currentTarget.value;
          app.filterPostions(filters, positionsList);

          $('.comeet-listing--open-number').html(positionsList.matchingItems.length);
        });
      }
    },
    filterPostions: function(filters, positionsList) {
      positionsList.filter(
        item => (filters.location === item.values().location || filters.location === 'Location') &&
                (filters.department === item.values().department || filters.department === 'Department'));
    },
    loopHomeVideo: function() {
      if( $('.home-hero').length > 0 ) {
        var homeVideo = document.getElementById('homepage-hero-video');
        var homeVideoLoop = document.getElementById('homepage-hero-video-loop');
        $(homeVideoLoop).hide();

        homeVideo.addEventListener('ended', function() {
          homeVideoLoop.play();
          $(homeVideoLoop).show();
          $(homeVideo).hide();
        }, false);

        homeVideo.play();
      }
    },
    initAboutSlider: function() {
      if( $('.about-image-slider').length > 0 ) {
        const swiper = new Swiper('.about-image-slider--swiper', {
          direction: 'horizontal',
          loop: true,
          autoplay: true,
          effect: 'fade',
          crossFade: true,
          disableOnInteraction: false,
          allowSlideNext: true,
          allowSlidePrev: true,
          allowTouchMove: true,

          pagination: {
            el: '.swiper-pagination',
          }
        });
      }
    },
    initTooltips: function() {
      $('[data-toggle="tooltip"]').tooltip();
    },
    cloneEventInfoStrip: function() {
      if( $('.event-date-time-strip .info-group').length > 0 ) {
        if( $(window).width() > 991 ) {
          var e = jQuery('.event-date-time-strip .info-group');
        
          for (var i = 0; i < 5; i++) {
            e.clone().insertAfter(e);
          }
        }
      }
    },
    handleHubspotConsentBottomAnnouncementMove: function() {
      if( $('.bottom-announcement').length > 0 ) {
        var _hsp = window._hsp = window._hsp || [];
        _hsp.push(['addPrivacyConsentListener', (consent) => {
          if( consent.allowed ) {
            $('.bottom-announcement').addClass('resetPosition');
          }
        }
        ]);
      }
    },
    initBlogLoadMore: function() {
      if( $('.blog-listing').length > 0 ) {
        $('a.blog-load-more').on('click', function(e){
          e.preventDefault();

          var items = [];

          $(document).find('.blog-listing--single').each(function(){
            var pid = $(this).attr('data-post-id');
            items.push(pid);
          });

          var payload = {
            'action': 'load_more_posts',
            'args': {
              'items': items
            }
          }

          $.ajax({
              url: gk8_app.ajaxurl,
              data: payload,
              type: 'POST',
              success: function (response) {
                if (response.end !== undefined) {
                  $('.blog-load-more-wrapper').append('<span class="no-more-posts">' + response.end + '</span>');
                  $('.blog-load-more').hide();
                } else {
                  $('.blog-lobby').append(response);
                  app.matchHeightElem();
                }
              }
          });
        });
      }
    },
    initNewsLoadMore: function() {
      if( $('.news-listing').length > 0 ) {
        $('a.news-load-more').on('click', function(e){
          e.preventDefault();

          var items = [];

          $(document).find('.news-listing--single').each(function(){
            var pid = $(this).attr('data-post-id');
            items.push(pid);
          });

          var payload = {
            'action': 'load_more_news',
            'args': {
              'items': items
            }
          }

          $.ajax({
              url: gk8_app.ajaxurl,
              data: payload,
              type: 'POST',
              success: function (response) {
                if (response.end !== undefined) {
                  $('.news-load-more-wrapper').append('<span class="no-more-posts">' + response.end + '</span>');
                  $('.news-load-more').hide();
                } else {
                  $('.news-lobby').append(response);
                  app.matchHeightElem();
                }
              }
          });
        });
      }
    },
    initResourcesLoadMore: function() {
      if( $('.resources-listing').length > 0 ) {
        $('a.resources-load-more').on('click', function(e){
          e.preventDefault();

          var items = [];

          $(document).find('.resources-listing--single').each(function(){
            var pid = $(this).attr('data-post-id');
            items.push(pid);
          });

          var payload = {
            'action': 'load_more_resources',
            'args': {
              'items': items
            }
          }

          $.ajax({
              url: gk8_app.ajaxurl,
              data: payload,
              type: 'POST',
              success: function (response) {
                if (response.end !== undefined) {
                  $('.resources-load-more-wrapper').append('<span class="no-more-posts">' + response.end + '</span>');
                  $('.resources-load-more').hide();
                } else {
                  $('.resources-lobby').append(response);
                  app.matchHeightElem();
                }
              }
          });
        });
      }
    },
    initUpcomingLoadMore: function() {
      if( $('.upcoming-listing').length > 0 ) {
        $('a.upcoming-load-more').on('click', function(e){
          e.preventDefault();

          var items = [];

          $(document).find('.upcoming-listing--single').each(function(){
            var pid = $(this).attr('data-post-id');
            items.push(pid);
          });

          var payload = {
            'action': 'load_more_upcoming',
            'args': {
              'items': items
            }
          }

          $.ajax({
              url: gk8_app.ajaxurl,
              data: payload,
              type: 'POST',
              success: function (response) {
                if (response.end !== undefined) {
                  $('.upcoming-load-more-wrapper').append('<span class="no-more-posts">' + response.end + '</span>');
                  $('.upcoming-load-more').hide();
                } else {
                  $('.upcoming-lobby').append(response);
                  app.matchHeightElem();
                }
              }
          });
        });
      }
    },
    hashFixNavs: function() {
      if( $('.nav-footer').length > 0 ) {
        $(document).find('.nav-footer a[href="#"').each(function(){
          $(this).on('click', function(e) {
            e.preventDefault();
          });
        });
      }
      
      if( $('.nav-main').length > 0 ) {
        $(document).find('.nav-main a[href="#"').each(function(){
          $(this).on('click', function(e) {
            e.preventDefault();
          });
        });
      }
    },
    matchHeightElem: function() {
      if( $(document).find('.element-matchheight').length > 0 ) {
        $(document).find('.element-matchheight h4').matchHeight();
      }
    },
    initSticksy: function() {
      if( $(document).find('.sticksy').length > 0 ) {
        var stickyEl = new Sticksy('.sticksy', {
          topSpacing: 70
        });
        stickyEl.onStateChanged = function (state) {
          if(state === 'fixed') {
            stickyEl.nodeRef.classList.add('widget--sticky')
          } else {
            stickyEl.nodeRef.classList.remove('widget--sticky')
          }
        }
      }
    },
    initVimeoVids: function() {
      if( $(document).find('.resources-single--vimeo-video-holder').length > 0 ) {
        var options = {
          vimeo_logo: false,
          byline: false,
          title: false,
          portrait: false
        };

        var player = new Vimeo.Player('player', options);
      }
    },
    resetPulledUpForm: function() {
      if( $(document).find('.form-container.pull-up').length > 0 ) {
        window.onscroll = function() {
          if (window.scrollY > 300) {
            $(document).find('.form-container.pull-up').removeClass('pull-up');
          }
          
          if (window.scrollY < 300) {
            $(document).find('.form-container').addClass('pull-up');
          }
        };
      }
    },
    smoothScroll: function(anchor, offset){
      let duration = 1000;
      let targetY = $(anchor).offset().top - (offset);
      $("html, body").animate({
        "scrollTop" : targetY
      }, duration);
    },
  };
  
  app.init();
  
  $(function(){
    app.domReady();
  });
  
  $(window).on('scroll', function(e){
    // 
  });
  
  $(window).on('load', function(e){
    app.windowLoad();
  });
  
  $(window).on('resize scroll', function(e){
    app.windowResizeScroll();
  });
  
  $(window).on('resize', function(){
    app.windowResize();
  });
  
  $(window).on('load resize', function(e){
    // 
	});
  
  $(window).on('pageshow', function(e) {
    //
  });
})(jQuery);
